import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import { Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { connectModal } from '../../../features/modal/hoc';
import { apiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { accountRoles } from '../../../common/enums';
import {
  selectAccounts,
  selectAccountsPagination,
  selectAccountsFilter,
  fetchAccountsActions,
  setAccountsFilterAction,
} from '../../../features/account-management/ducks';
import {
  Search,
  RegistrationStatus,
} from '../../../features/account-management/components/filters';
import { AccountTable } from '../../../features/account-management/components';
import { apiCallIds as accountApiCallIds } from '../../../features/account-management/api';

const mapStateToProps = state => ({
  accounts: selectAccounts(state),
  pagination: selectAccountsPagination(state),
  filter: selectAccountsFilter(state),
  isLoadingAccounts: selectIsInProgress(state, accountApiCallIds.FETCH_ACCOUNTS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccounts: fetchAccountsActions.request,
      setFilter: setAccountsFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  role: [accountRoles.CREDITOR],
  search: '',
  registrationStatus: 'ACCOUNT_ACTIVE',
};

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.ASSIGN_TO_CREDITOR)
export default class CreditorPaymentModal extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    actions: PropTypes.object.isRequired,
    accounts: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoadingAccounts: PropTypes.bool.isRequired,
  };

  onModalMount = () => {
    const { actions } = this.props;
    actions.setFilter(defaultFilter);
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAccounts({
      ...this.props.filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };

  onFilterSearchChange = this.onFilterChange('search');

  onFilterStatusChange = this.onFilterChange('registrationStatus');

  render() {
    const {
      modalActions,
      isLoading,
      isVisible,
      accounts,
      pagination,
      filter,
      isLoadingAccounts,
      onSubmit,
      children,
    } = this.props;

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        {isVisible && (
          <ModalWindow
            hideModal={modalActions.hide}
            isLoading={isLoading}
            onSubmit={onSubmit}
            filter={filter}
            onFilterSearchChange={this.onFilterSearchChange}
            onFilterStatusChange={this.onFilterStatusChange}
            accounts={accounts}
            pagination={pagination}
            handleTableChange={this.handleTableChange}
            isLoadingAccounts={isLoadingAccounts}
            onModalMount={this.onModalMount}
          />
        )}
      </span>
    );
  }
}

@translate()
class ModalWindow extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    accounts: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    handleTableChange: PropTypes.func.isRequired,
    isLoadingAccounts: PropTypes.bool.isRequired,
    onModalMount: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onModalMount();
  }

  render() {
    const {
      t,
      hideModal,
      isLoading,
      onSubmit,
      filter,
      onFilterSearchChange,
      onFilterStatusChange,
      accounts,
      pagination,
      handleTableChange,
      isLoadingAccounts,
    } = this.props;

    return (
      <Modal
        title={t('Zvoľte investora')}
        visible
        confirmLoading={isLoading}
        onCancel={hideModal}
        footer={[
          <Button size="small" key="back" onClick={hideModal}>
            {t('Zrušiť')}
          </Button>,
        ]}
        width={900}
      >
        <Row center="xs" className="filters">
          <Col xs={12} sm={6}>
            <Search
              key="creditorSearch"
              defaultValue={filter.search}
              onSearch={onFilterSearchChange}
            />
          </Col>
          <Col xs={12} sm={6}>
            <RegistrationStatus
              key="creditorStatus"
              value={filter.registrationStatus}
              onChange={onFilterStatusChange}
            />
          </Col>
        </Row>

        <AccountTable
          accounts={accounts}
          pagination={pagination}
          onChange={handleTableChange}
          loading={isLoadingAccounts}
          actions={(text, account) => (
            <Button size="small" onClick={() => onSubmit(account.id)}>
              {t('Priradiť')}
            </Button>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/components/CreditorPaymentModal.js